module.exports = __webpack_public_path__ + "img/news2-5.af3045c0.png";